<p-breadcrumb
  [model]="[
    {
      label: 'Valores de atributos',
      routerLink: ['/variation-attribute-values'],
    },
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Valores de Atributos</h5>
      <p>Gerencie os valores de atributos disponíveis para produtos</p>
    </div>
    <p-button
      label="Novo Valor"
      routerLink="/variation-attribute-values/create"
      rounded
    />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="variationAttributeValues()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="displayNameFilter"
          class="block"
          [(ngModel)]="displayNameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome de exibição"
          fluid
        />
      </div>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="valueFilter"
          class="block"
          [(ngModel)]="valueFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Valor"
          fluid
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Atributo</th>
      <th>Valor</th>
      <th>Nome de exibição</th>
      <th>Dados extras</th>
      <th>Ordem</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.variationAttributeName }}</td>
      <td>{{ item.value }}</td>
      <td>{{ item.displayName }}</td>
      <td>{{ item.extraData || "-" }}</td>
      <td>{{ item.sortOrder }}</td>
      <td>
        <div
          class="flex justify-start"
          (click)="requestUpdateStatus(item, $event)"
        >
          <div class="flex items-center gap-2">
            <p-toggleswitch
              [ngModel]="item.isActive"
              [style.pointer-events]="'none'"
            ></p-toggleswitch>
            {{ item.isActive ? "Ativo" : "Inativo" }}
          </div>
        </div>
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/variation-attribute-values/update/' + item.id"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
<p-confirmdialog />
